/**
 * CORE-1205 — куда неавторизованному можно на нативе.
 *
 * До 15.09.2026 приложение пускало без входа только в экраны входа
 * (`AUTH_PUBLIC_ROUTES` в App.tsx), и ссылка на Live-сессию сбрасывала человека
 * на логин. Решение владельца 15.09.2026: как на вебе, по ссылке гость попадает
 * в Live-сессию — и только в неё. Поднять руку или написать в чат он не может:
 * комната просит войти и возвращает его обратно после входа.
 *
 * Чистая функция без RN-зависимостей — пиньится в node-jest.
 */

/** Экраны самой Live-сессии: предбанник с именем гостя и комната. */
export const GUEST_LIVE_ROUTES: ReadonlySet<string> = new Set(['LiveSessionEntry', 'LiveRoomSession']);

export type GuestRouteAccess =
  | { kind: 'allow' }
  /** Ссылка «Поделиться» (`/room/<код>`) ведёт на анонс, а гостю — в предбанник. */
  | { kind: 'entry'; roomId: string }
  | { kind: 'login' };

export function resolveGuestRouteAccess(route: { name: string; params?: object }): GuestRouteAccess {
  if (GUEST_LIVE_ROUTES.has(route.name)) return { kind: 'allow' };
  if (route.name === 'RoomAnnouncement') {
    const roomId = (route.params as { roomId?: unknown } | undefined)?.roomId;
    if (roomId != null && String(roomId) !== '') return { kind: 'entry', roomId: String(roomId) };
  }
  return { kind: 'login' };
}
